import styled from 'styled-components';

export const StyledEditorLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: ${({ theme }) => theme.colors.surface};
`;
